import { TmBaseError } from '@/core/error/tmBaseError'

export class TmLostConnectionError<T extends Record<string, unknown>> extends TmBaseError<T> {
  public name = 'TmLostConnectionError'

  protected isMonitored = false
}
